$(document).ready(function () {
    var modalCount = 0;

    var modalContent = $('#mcui-modal-content');
    function displayModal(e) {
        // Gather key components from clicked trigger
        e.preventDefault();
    
        var modalType = $(this).data('modal-type');
        var docID = $(this).data('docid');
        var widgetName = "";
        if ($(this).is("*[data-widgetname]")){
            widgetName = $(this).data("widgetname");
        }
        else {
            var controllerEl = $(this).closest('*[data-widget-name]');
            if (controllerEl.length > 0) {
                // Get the "data-widget-name" attribute and remove "Widget" and "Controller" from the name
                widgetName = controllerEl.attr("data-widget-name").replace("Widget", "").replace("Controller", "");
                // Add spaces bewteen lowercase and uppercase letters
                widgetName = widgetName.replace(/([a-z])([A-Z])/g, "$1 $2");
            }
        }

        // Generate content markup based on the type of modal triggered
        if (modalType === "youtube") {
            var iframeId = `modal-yt-${modalCount}`;
            modalCount++;
            modalContent.html(`<div class="ratio ratio-16x9"><div id="${iframeId}" frameborder="0"></div></div>`);
            var playerOptions = {
                videoId: docID,
                width: 515,
                height: 290,
                playerVars: {
                    'autoplay': 1
                },
            };
            /* eslint-disable-next-line no-unused-vars */
            var player = new YouTubePlayer(iframeId, playerOptions);
        }
        else {
            console.log("Modal legacy video form");
            var languagePrefix = AppState.GetCurrentLanguageUrlPrefix();
            var iframeSrc = `${languagePrefix}/resources/mcui-video-form?c=${docID}&widgetName=${encodeURIComponent(widgetName)}`;
            modalContent.html(`<iframe id="mcui-modal-iframe" class="embed-responsive-item" src="${iframeSrc}">`);
        }
        hideSpinner();
        // Shut of videos on modal close
        // $('#mcui-modal').on('hidden.bs.modal', function () {
        //     console.warn("modalContent: ", modalContent);
        //     $('#mcui-modal').off('hidden.bs.modal');
        //     modalContent.html('');
        //     $('#mcui-modal #loader').removeClass('d-none').addClass('d-flex');
        // });
        $(document).on('click', '.mcui-modal', function(e) {
            if(e.target.classList.contains("mcui-modal") || e.target.parentElement.classList.contains("close-button")) {
                $('#mcui-modal-content').html('');
                $('#mcui-modal #loader').removeClass('d-none').addClass('d-flex');
            }
        });
    }

    // Hide spinner when iFrame loads
    function hideSpinner() {
        var theFrame = $('#mcui-modal-iframe');
        theFrame.on('load', function () {
            $('#mcui-modal #loader').removeClass('d-flex').addClass('d-none');
        });
    }

    // Bind modal display function to all <a> with ID for modal
    $(document).on('click', '[href="#mcui-modal"]', displayModal);
});